import { RequestError } from 'src/common-services'

export async function ifNotFound<T, U>(fetcher: Promise<T> | (() => Promise<T>), defaultValue: U): Promise<T | U> {
  return await (typeof fetcher === 'function' ? fetcher() : fetcher).catch((error) => {
    if (error instanceof RequestError) {
      if (error.status !== 404) {
        throw error
      }
    }
    return defaultValue
  })
}

export async function ifNotServerError<T, U>(
  fetcher: Promise<T> | (() => Promise<T>),
  defaultValue: U
): Promise<T | U> {
  return await (typeof fetcher === 'function' ? fetcher() : fetcher).catch((error) => {
    if (error instanceof RequestError) {
      if (error.status >= 500) {
        throw error
      }
    }
    return defaultValue
  })
}
